import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import CarCard from "@/components/CarCard";
import LogoAssembly from "@/components/LogoAssembly";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

export default function FeaturedCars() {
  const { lang } = useLang();
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/cars", { params: { page: 1, limit: 6, status: "available", sort: "recent" } })
      .then((r) => setCars(r.data || []))
      .catch(() => setCars([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section id="vetture-featured" className="relative py-32 sm:py-48 px-6 sm:px-10 lg:px-14 max-w-[1600px] mx-auto overflow-hidden" data-testid="featured-cars-section">
      {/* Logo che si assembla come un motore meccanico */}
      <LogoAssembly />

      <div className="relative z-10 flex items-end justify-between flex-wrap gap-8 mb-16">
        <div>
          <div className="flex items-center gap-4 mb-8">
            <span className="w-10 h-px bg-white/40" />
            <span className="label-eyebrow text-white/70">{lang === "en" ? "The collection" : "La collezione"}</span>
          </div>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1 }}
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.0] tracking-tight text-white"
          >
            {lang === "en" ? "Cars for sale" : "Vetture in vendita"}<br />
            <span className="italic text-neutral-500">{lang === "en" ? "each hand-picked." : "scelte una per una."}</span>
          </motion.h2>
        </div>
        <Link to="/vetture" className="btn-magnetic" data-testid="see-all-cars">
          {lang === "en" ? "View all" : "Vedi tutte"}
        </Link>
      </div>

      {loading ? (
        <div className="relative z-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
          {[0, 1, 2].map((i) => (
            <div key={i} className="aspect-[4/3] bg-neutral-900/60 animate-pulse" />
          ))}
        </div>
      ) : cars.length === 0 ? (
        <div className="relative z-10 border border-white/10 py-24 text-center">
          <p className="label-eyebrow text-neutral-500 mb-4">{lang === "en" ? "No cars published" : "Nessuna vettura pubblicata"}</p>
          <p className="font-serif italic text-2xl text-neutral-400">{lang === "en" ? "The collection is being updated." : "La collezione è in aggiornamento."}</p>
        </div>
      ) : (
        <div className="relative z-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-20">
          {cars.map((c, i) => (
            <CarCard key={c.id} car={c} index={i} />
          ))}
        </div>
      )}
    </section>
  );
}
